export default "__VITE_ASSET__0s3UTQg1__"